import { Typography } from "@mui/material";
import React from "react";
import { FooterButton } from "../../ServiceFunctionsModal.styles";
import { SERVICE_MODALS_OPTIONS_STATES } from "../../ServiceFunctionsModal.types";
import { ContentTypography } from "../ServiceModal.styles";
import {
    RESPONSE_CODE_RESOURCE_NOT_FOUND,
    RESPONSE_CODE_RESOURCE_SUSPENDED,
} from "@infrastructure/BackendClientCodes";
import { PostType } from "../../../Post/Post.types";
import {
    RESET_API_CACHE_REASONS,
    resetIgnoreApiCacheTime,
} from "@infrastructure/Services/ApiUtility";
import { deletePost } from "@infrastructure/Services/PostService";

export default function DeletingPostConfirmation(
    setModalCurrentAction: (newAction: SERVICE_MODALS_OPTIONS_STATES) => void,
    selectedPost: PostType,
    onSelectedPostSuccessDeleteHandler: (postId: number) => void,
) {
    function onSelectedPostDeleteHandler() {
        deletePost(selectedPost.id)
            .then(() => {
                resetIgnoreApiCacheTime(RESET_API_CACHE_REASONS.POST_DELETE);
                onSelectedPostSuccessDeleteHandler(selectedPost.id);
                setModalCurrentAction(
                    SERVICE_MODALS_OPTIONS_STATES.DELETED_POST,
                );
            })
            .catch((reason) => {
                if (
                    reason.response?.status ===
                        RESPONSE_CODE_RESOURCE_SUSPENDED ||
                    reason.response?.status === RESPONSE_CODE_RESOURCE_NOT_FOUND
                ) {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.REPORTED_CONTENT_RESTRICTED,
                    );
                } else {
                    setModalCurrentAction(
                        SERVICE_MODALS_OPTIONS_STATES.UNSUCCESSFUL_DELETING_POST,
                    );
                }
            });
    }

    const modalTitle = <Typography>Beitrag wirklich löschen?</Typography>;
    const modalContent = (
        <ContentTypography>
            Der Beitrag wird endgültig gelöscht und kann nicht wieder
            hergestellt werden.
        </ContentTypography>
    );
    const modalActions = (
        <FooterButton variant={"text"} onClick={onSelectedPostDeleteHandler}>
            Beitrag löschen
        </FooterButton>
    );
    return { modalTitle, modalContent, modalActions };
}
